import React, { useMemo } from 'react';
import { makeStyles } from '@material-ui/core/styles';
import ListAlt from '@material-ui/icons/ListAlt';
import WbIncandescent from '@material-ui/icons/WbIncandescent';
import ShoppingBasket from '@material-ui/icons/ShoppingBasket';
import GridContainer from '@/components/material-ui-kit/components/Grid/GridContainer';
import GridItem from '@/components/material-ui-kit/components/Grid/GridItem';
import FavoriteMenuList from '@/components/favorites/FavoriteMenuList';
import FavoriteIdeaList from '@/components/favorites/FavoriteIdeaList';
import FavoriteShoppingList from '@/components/favorites/FavoriteShoppingList';
import NavPills from '@/components/common/ui/NavPills';
import styles from 'styles/jss/original/components/favorites/FavoriteTab';
import { IMenu, IIdea, IShopping } from '@/@types/generated/contentful';

const useStyles = makeStyles(styles);

type ComponentProps = {
  menuList: IMenu[];
  ideaList: IIdea[];
  shoppingList: IShopping[];
  isLoading: boolean;
};

const FavoriteTab: React.FC<ComponentProps> = ({ menuList, ideaList, shoppingList, isLoading }) => {
  const classes = useStyles();
  const favoriteTabProps = useMemo(
    () => [
      {
        tabButton: '献立',
        tabIcon: ListAlt,
        tabContent: <FavoriteMenuList menuList={menuList} isLoading={isLoading} />
      },
      {
        tabButton: 'アイデア',
        tabIcon: WbIncandescent,
        tabContent: <FavoriteIdeaList ideaList={ideaList} isLoading={isLoading} />
      },
      {
        tabButton: 'ショッピング',
        tabIcon: ShoppingBasket,
        tabContent: <FavoriteShoppingList shoppingList={shoppingList} isLoading={isLoading} />
      }
    ],
    [menuList, ideaList, shoppingList, isLoading]
  );
  return (
    <div className={classes.section}>
      <div className={classes.container}>
        <GridContainer>
          <GridItem>
            <NavPills color='warning' tabs={favoriteTabProps} alignCenter />
          </GridItem>
        </GridContainer>
      </div>
    </div>
  );
};

export default FavoriteTab;
